import { observer } from 'mobx-react-lite';
import { ConfirmPopup } from './Popup';

export interface DeleteConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  /** delete: İptal/Sil — yesNo: Hayır/Evet */
  mode?: 'delete' | 'yesNo';
  closeOnConfirm?: boolean;
}

const DeleteConfirmationDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  mode = 'delete',
  closeOnConfirm,
}: DeleteConfirmationDialogProps) => {
  const isYesNo = mode === 'yesNo';

  const result = (
    <ConfirmPopup
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      intent={isYesNo ? 'info' : 'delete'}
      title={title ?? (isYesNo ? 'Silme Onayı' : undefined)}
      message={
        message ??
        (isYesNo
          ? 'Bu öğeyi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.'
          : undefined)
      }
      cancelLabel={isYesNo ? 'Hayır' : undefined}
      confirmLabel={isYesNo ? 'Evet' : undefined}
      closeOnConfirm={closeOnConfirm ?? !isYesNo}
      dangerMessage={!isYesNo}
    />
  );

  return result;
};

export default observer(DeleteConfirmationDialog);
